/**
 * Sound system constants + helpers.
 *
 * 21 preset notification sounds ship in `public/sounds/wx-nt_*.mp3`.
 * Operator picks one for inbound + one for outbound, or uploads a
 * custom file (URL stored on the integration). Visitor's mute
 * preference (localStorage `wexio:sound-muted`) overrides everything.
 */

import { assetUrl } from "./asset-url";

export const PRESET_SOUND_IDS = Array.from({ length: 21 }, (_, i) => `wx-nt_${i + 1}`);

export type PresetSoundId = (typeof PRESET_SOUND_IDS)[number];

const PRESET_PREFIX = "wx-nt_";

/**
 * Resolve a sound identifier to a fetchable URL. Preset ids like
 * `"wx-nt_3"` map to the bundled MP3 at `/sounds/wx-nt_3.mp3` — routed
 * through `assetUrl` so cross-origin embeds (the React component on a
 * host page) fetch it from the widget's CDN rather than the host's
 * origin. Fully-qualified URLs (operator-uploaded customs) pass
 * through. Anything else returns `null` so callers can no-op silently.
 */
export function resolveSoundUrl(id: string | null | undefined): string | null {
  if (!id) return null;
  if (id.startsWith("http://") || id.startsWith("https://")) {
    return id;
  }
  if (id.startsWith(PRESET_PREFIX)) {
    return assetUrl(`/sounds/${id}.mp3`);
  }
  return null;
}

export const MUTE_STORAGE_KEY = "wexio:sound-muted";
